document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-kg-sfp]").forEach(function (section) {
    var el = section.querySelector("[data-kg-sfp-swiper]");
    if (!el || typeof Swiper === "undefined") return;

    var prev = section.querySelector(".kg-sfp__nav-btn--prev");
    var next = section.querySelector(".kg-sfp__nav-btn--next");

    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 12,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });
});
